import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Galleries from '@/components/Galleries'
import Items from '@/components/Items'
import Item from '@/components/Item'
import Login from '@/components/Login'
import Account from '@/components/Account'
import Welcome from '@/components/Welcome'
import Terms from '@/components/Terms'
import NotFound from '@/components/NotFound'

import firebase from 'firebase'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/capture',
      name: 'Capture',
      component: Home,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/',
      name: 'Items',
      component: Items,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/capture/:id',
      name: 'CaptureItem',
      component: Home,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/galleries',
      name: 'Galleries',
      component: Galleries,
      meta: {
        requiresAuth: true
      }
    },
    // {
    //   path: '/photos',
    //   name: 'Photos',
    //   component: Photos,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    {
      path: '/items',
      name: 'Items',
      component: Items,
      meta: {
        requiresAuth: true,
        showKeep: false
      }
    },
    {
      path: '/keepers',
      name: 'Keep',
      component: Items,
      meta: {
        requiresAuth: true,
        showKeep: true
      }
    },
    {
      path: '/item/:id',
      name: 'Item',
      component: Item,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/account',
      name: 'Account',
      component: Account,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/welcome',
      name: 'Welcome',
      component: Welcome,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/terms',
      name: 'Terms',
      component: Terms,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    }, {
      path :'*',
      component:NotFound
    }
  ]
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
  const currentUser = firebase.auth().currentUser

  if (!["Welcome", "Login", "Terms"].includes(to.name) && !currentUser) {
    next('/welcome')
  } else if (requiresAuth && currentUser) {
    next()
  } else {
    next()
  }
})

router.afterEach((to, from) => {
  const currentUser = firebase.auth().currentUser
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({event: "page_view", page_name: to.name, page_path: to.path, prev_page_path: from.path, is_anonymous: !currentUser})
})

export default router